import * as React from "react";
import {
  SimpleForm,
  TextInput,
  Create,
  CreateProps,
  BooleanInput,
  SelectInput,
} from "react-admin";

import { useGetList } from "react-admin";

export const CreateCategory: React.FC<CreateProps> = (props) => {
  const { data: categories = [], isLoading: isLoadingCategories } = useGetList("categories", {
    filter: { isRoot: true },
    pagination: { page: 1, perPage: 100 },
  });

  const [isRootCategory, setIsRootCategory] = React.useState(true);

  const handleIsRootCategoryChange = React.useCallback(() => {
    setIsRootCategory((prev) => !prev);
  }, []);

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" fullWidth required label="Nombre" />
        <BooleanInput
          source="isRoot"
          label="Es categoría padre"
          defaultValue={true}
          onChange={handleIsRootCategoryChange}
        />
        {!isRootCategory && (
          <SelectInput
            source="parentId"
            choices={isLoadingCategories ? [] : categories}
            fullWidth
            label="Categoría padre"
            disabled={isLoadingCategories}
          ></SelectInput>
        )}
      </SimpleForm>
    </Create>
  );
};
